import { render, staticRenderFns } from "./SelectWrappers.vue?vue&type=template&id=1871b1db"
import script from "./SelectWrappers.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectWrappers.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SelectWrappers.vue?vue&type=style&index=0&id=1871b1db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports